<template>
    <section id="contactDetail">
        <div class="container text-center">
            <div class="row">
                <div class="col-md-3">
                    <div class="contact-card">
                        <i class="fa fa-location-dot"></i>
                        <h2 class="bg1">{{ $t("contact.location.title") }}</h2>
                        <p>{{ $t("contact.location.description") }}</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="contact-card">
                        <i class="fa fa-phone"></i>
                        <h2 class="bg2">{{ $t("contact.phone.title") }}</h2>
                        <p>(+31 ) 6 40069756</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="contact-card">
                        <i class="fa fa-envelope"></i>
                        <h2 class="bg3">EMAIL</h2>
                        <p>info@merwylan.nl</p>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="contact-card">
                        <i class="fa fa-clock"></i>
                        <h2 class="bg4">{{ $t("contact.availability.title") }}</h2>
                        <p>{{ $t("contact.availability.weekdays") }}<br />
                            {{ $t("contact.availability.weekends") }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ContactDetail',
};
</script>
